import classNames from 'classnames';
import { useCallback } from 'react';
import { Button, ButtonProps } from 'yoso';
import { useNotificationInfo } from '~/components/Dosi/Notification/Notification.hooks';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { Bell } from '~/components/Icon';
import styles from './NotificationButton.module.scss';

export type NotificationButtonProps = ButtonProps;

const PROFILE_URL = import.meta.env.VITE_PROFILE_URL;

const notificationUrl = `${PROFILE_URL}/noti`;

export const NotificationButton = ({ className, ...props }: NotificationButtonProps) => {
  const {
    data: { hasUnreadNotification },
  } = useNotificationInfo({ useErrorBoundary: false });
  const { active, src, open, close } = useEmbeddedViewer();
  const onClick = useCallback(() => {
    if (active && src === notificationUrl) {
      close();
    } else {
      open(notificationUrl);
    }
  }, [active, close, open, src]);
  return (
    <Button
      className={classNames(styles.root, className)}
      variant="transparent"
      onClick={onClick}
      {...props}>
      <Bell display="block" dot={hasUnreadNotification} />
    </Button>
  );
};
